export default __webpack_public_path__ + "static/media/kids-shoes.c6fc4b91.png";